import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-a.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-a.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationAConstants } from "./create-application-location-a.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PopUpComponent } from "../../../../shared/components/pop-up/pop-up.component";
export let CreateApplicationLocationAComponent = class CreateApplicationLocationAComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    mapTools;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    modalService;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    showMap = false;
    activeTabIndex;
    advertisementsForm;
    descriptionLabel1 = CreateApplicationLocationAConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationAConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationAConstants.DESCRIPTION_LABEL_3;
    validationMessages = CreateApplicationLocationAConstants.VALIDATION_MESSAGES;
    advertisementsFormGroupName = CreateApplicationLocationAConstants.ADVERTISEMENT_FORM_GROUP_NAME;
    advertisementsFormControlName = CreateApplicationLocationAConstants.ADVERTISEMENT_FORM_CONTROL_NAME;
    areaOfDisplayFormControlName = CreateApplicationLocationAConstants.AREA_OF_DISPLAY_FORM_CONTROL_NAME;
    isAdvertisementPermanentOrTemporaryFormControlName = CreateApplicationLocationAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME;
    layerReference = CreateApplicationLocationAConstants.LAYER_REFERENCE;
    applicationTypeFormControlName = CreateApplicationLocationAConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    typeLabel = CreateApplicationLocationAConstants.APPLICATION_TYPE_LABEL;
    streetNamesFormControl = CreateApplicationLocationAConstants.STREET_NAMES_FORM_CONTROL;
    propertyDescriptionFormControlName = CreateApplicationLocationAConstants.PROPERTY_DESCRIPTION_FORM_CONTROL_NAME;
    addressOrStreetFormControlName = CreateApplicationLocationAConstants.ADDRESS_OR_STREET_FORM_CONTROL_NAME;
    areaOfDisplayLabel = CreateApplicationLocationAConstants.AREA_OF_CONTROL_LABEL;
    streetNamesLabel = CreateApplicationLocationAConstants.STREET_NAMES_LABEL;
    propertyDescriptionLabel = CreateApplicationLocationAConstants.PROPERTY_DESCRIPTION_LABEL;
    addressOrStreetLabel = CreateApplicationLocationAConstants.ADDRESS_OR_STREET_LABEL;
    removeAdvertisementLabel = CreateApplicationLocationAConstants.REMOVE_ADVERTISEMENT_LABEL;
    isAdvertisementPermanentOrTemporaryFormLabel = CreateApplicationLocationAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL;
    selectedApplicationStatus;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    areaOfDisplayLookups = LookupConstants.AREA_OF_DISPLAY_LOOKUPS_A;
    showPermanentApplicationsFields = false;
    showTemporaryApplicationsFields = false;
    permanentOrTemporaryLookupOptions = CreateApplicationLocationAConstants.PERMANENT_OR_TEMPORARY_LOOKUPS_A;
    applicationTypesLookups = [];
    isMapLoaded = false;
    sketchTool;
    selectedGraphic = null;
    mapComponent;
    constructor(applicationCreateService, mapTools, aflaModuleStrategyService, selectedApplicationService, appControllerService, modalService, mapService, requestStatusService, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.mapTools = mapTools;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.modalService = modalService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.getLookups();
        this.setupSubscribers();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.initializeSketchTools();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
        super.ngOnDestroy();
    }
    loadMetadata() {
    }
    onPermanentOrTemporaryAdvertisementSelected($event) {
        const advertisementType = $event.target.value;
        const advertisementFormArray = this.getAdvertisements();
        if (advertisementFormArray.length > 0) {
            this.confirmChangeFromUser(advertisementType);
        }
        else {
            this.handleAdvertisementTypeValueChanged(advertisementType);
        }
    }
    getAdvertisements() {
        return this.advertisementsForm.get(this.advertisementsFormControlName);
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getAdvertisements().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveFeature(featureIndex) {
        this.getAdvertisements().removeAt(featureIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.advertisementsForm = this.aflaModuleStrategyService.form.get(this.advertisementsFormGroupName);
    }
    setAdvertisementData(propertyObject, geometry) {
        try {
            this.requestStatusService.showBusySpinner("getAdvertisementData");
            let newAdvertisingFormGroup;
            if (propertyObject) {
                newAdvertisingFormGroup = this.setAdvertisingFormGroup(propertyObject, geometry);
            }
            else {
                newAdvertisingFormGroup = this.createAdvertisingFormGroup(geometry);
            }
            const url = this.getGPToolURL();
            const formData = this.getGPToolFormData(geometry);
            this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
                next: (trueCentroidResponse) => {
                    this.showFieldsAccordingToChosenApplicationStatus(newAdvertisingFormGroup);
                    this.setPropertyTrueCentroidData(newAdvertisingFormGroup, trueCentroidResponse);
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("getAdvertisementData");
                }, error: (error) => {
                    this.appControllerService.handleServerErrorMessage("propertyData", error, CRUDOperation.Get);
                    this.requestStatusService.removeBusySpinner("getAdvertisementData");
                }
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner("getAdvertisementData");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getAdvertisements().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            try {
                this.mapComponent.addGeometriesOnMap(geometries, this.layerReference, true);
            }
            catch (e) {
                this.requestStatusService.removeBusySpinner("getAdvertisementData");
            }
        }
    }
    subscribeToAdvertisement() {
        this.cleanupAfterDestroy(this.mapService.$selectedProperty).subscribe(property => {
            if (property !== null) {
                const objectId = this.featureDataAlternateColumnName(property.attributes, "OBJECTID", "objectId");
                const propertyHasAlreadyBeenAddedBefore = this.checkIfSelectedPropertyHasAlreadyBeenAdded(objectId);
                if (!propertyHasAlreadyBeenAddedBefore) {
                    this.setAdvertisementData(property.attributes, property.geometry);
                }
            }
        });
    }
    checkIfSelectedPropertyHasAlreadyBeenAdded(objectId) {
        let featureHasAlreadyBeenAddedBefore = false;
        this.getAdvertisements().controls.forEach(item => {
            const check = item.get("objectId").value;
            if (check === objectId) {
                featureHasAlreadyBeenAddedBefore = true;
                this.appControllerService.showMessage(CreateApplicationLocationAConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("add property");
            }
        });
        return featureHasAlreadyBeenAddedBefore;
    }
    featureDataAlternateColumnName(featureObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(featureObject)) {
            if (key === name1) {
                returnVal = featureObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = featureObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = featureObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    setAdvertisingFormGroup(property, geometry) {
        return new FormGroup({
            objectId: new FormControl(this.featureDataAlternateColumnName(property, "OBJECTID", "objectId")),
            areaOfDisplay: new FormControl(null),
            streetNames: new FormControl(null),
            streetOrAddress: new FormControl(null),
            addressStreetInformation: new FormControl(null),
            type: new FormControl(null, Validators.required),
            propertyDescription: new FormControl(null),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    getGPToolURL() {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        return `${proxyUrl}?${gpToolUrl}`;
    }
    getGPToolFormData(geometry) {
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        return formData;
    }
    setPropertyTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const advertisementsArray = this.getAdvertisements();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        advertisementsArray?.clear();
        advertisementsArray.push(newFormGroup);
        this.activeTabIndex = advertisementsArray.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    showFieldsAccordingToChosenApplicationStatus(newAdvertisingFormGroup) {
        if (this.selectedApplicationStatus?.toLowerCase() === "temporary") {
            this.addTemporaryAdvertisementFieldsValidators(newAdvertisingFormGroup);
            this.handleTemporaryApplicationSelected();
        }
        if (this.selectedApplicationStatus?.toLowerCase() === "permanent") {
            this.addPermanentAdvertisementFieldsValidators(newAdvertisingFormGroup);
            this.handlePermanentApplicationSelected();
        }
        this.changeDetectorRefs.detectChanges();
    }
    handleTemporaryApplicationSelected() {
        this.showPermanentApplicationsFields = false;
        this.showTemporaryApplicationsFields = true;
    }
    handlePermanentApplicationSelected() {
        this.showPermanentApplicationsFields = true;
        this.showTemporaryApplicationsFields = false;
    }
    initializeSketchTools() {
        this.sketchTool = this.mapTools.getMapTool("drawTool");
        this.mapTools.expandWidget("drawTool");
        if (this.selectedApplicationStatus.toLowerCase() === "temporary") {
            this.showMapToolsForTemporaryAdvertisement();
        }
        if (this.selectedApplicationStatus.toLowerCase() === "permanent") {
            this.showMapToolsForPermanentAdvertisement();
        }
        this.sketchTool.on("create", (event) => {
            if (event.state === "complete") {
                this.handleSketchComplete(event);
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
    }
    handleSketchComplete(event) {
        this.selectedGraphic = event.graphic;
        this.setAdvertisementData(null, this.selectedGraphic.geometry);
    }
    createAdvertisingFormGroup(geometry) {
        return new FormGroup({
            areaOfDisplay: new FormControl(null),
            streetNames: new FormControl(null),
            streetOrAddress: new FormControl(null),
            addressStreetInformation: new FormControl(null),
            type: new FormControl(null, Validators.required),
            propertyDescription: new FormControl(null),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    showMapToolsForTemporaryAdvertisement() {
        this.sketchTool.create("polygon");
        this.sketchTool.visibleElements = CreateApplicationLocationAConstants.POLYGON_SKETCH_TOOLS_OPTIONS;
    }
    showMapToolsForPermanentAdvertisement() {
        this.sketchTool.create("point");
        this.sketchTool.visibleElements = CreateApplicationLocationAConstants.POINT_SKETCH_TOOLS_OPTIONS;
    }
    confirmChangeFromUser(advertisementType) {
        const dialogRef = this.modalService.open(PopUpComponent, CreateApplicationLocationAConstants.MODAL_OPTIONS);
        dialogRef.componentInstance.title = CreateApplicationLocationAConstants.MODAL_DIALOG_TITLE;
        dialogRef.componentInstance.contentMessage = CreateApplicationLocationAConstants.MODAL_DIALOG_MESSAGE;
        dialogRef.componentInstance.data = true;
        dialogRef.result.then((canContinueMakingChanges) => {
            if (canContinueMakingChanges) {
                this.resetLocationDetails();
                this.handleAdvertisementTypeValueChanged(advertisementType);
                // if (this.selectedApplication && this.selectedApplication.id > 0) {
                //     this.clearApplicationValues(this.selectedApplication.id);
                // }
            }
            else {
                advertisementType.toLowerCase() === "temporary" ? this.selectedApplicationStatus = "permanent" : this.selectedApplicationStatus = "temporary";
            }
        });
    }
    resetLocationDetails() {
        this.showPermanentApplicationsFields = false;
        this.showTemporaryApplicationsFields = false;
        this.mapComponent.removeGraphicsFromMap(this.layerReference);
        const advertisementsArray = this.getAdvertisements();
        advertisementsArray.clearValidators();
        advertisementsArray.clear();
        this.changeDetectorRefs.detectChanges();
    }
    handleAdvertisementTypeValueChanged(advertisementType) {
        this.selectedApplicationStatus = advertisementType;
        if (this.showMap) {
            if (advertisementType?.toLowerCase() === "temporary") {
                this.showMapToolsForTemporaryAdvertisement();
            }
            if (advertisementType?.toLowerCase() === "permanent") {
                this.showMapToolsForPermanentAdvertisement();
            }
        }
        else {
            this.showMapFields();
        }
    }
    showMapFields() {
        this.showMap = true;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and name eq 'applicationType' and deleted eq false`,
        };
        this.cleanupAfterDestroy(this.applicationCreateService.getLookupsObservable(params)).subscribe({
            next: (response) => {
                const lookups = response.value;
                this.onGetLookupsCompleted(lookups);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("Lookups", error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(lookups) {
        this.applicationTypesLookups = [];
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypesLookups.push(lookUpContent);
            }
        });
        this.changeDetectorRefs.detectChanges();
    }
    addTemporaryAdvertisementFieldsValidators(newAdvertisingFormGroup) {
        newAdvertisingFormGroup.get(this.areaOfDisplayFormControlName).addValidators(Validators.required);
        newAdvertisingFormGroup.get(this.streetNamesFormControl).addValidators(Validators.required);
        newAdvertisingFormGroup.get(this.propertyDescriptionFormControlName).addValidators(Validators.required);
    }
    addPermanentAdvertisementFieldsValidators(newAdvertisingFormGroup) {
        newAdvertisingFormGroup.get(this.addressOrStreetFormControlName).addValidators(Validators.required);
    }
    setupSubscribers() {
        this.subscribeToAdvertisement();
        this.subscribeToClearGraphics();
        this.subscribeToSelectedApplication();
    }
    subscribeToClearGraphics() {
        this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getAdvertisements().clear();
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.advertisementsForm.reset();
                    this.showPermanentApplicationsFields = false;
                    this.showTemporaryApplicationsFields = false;
                    this.showMap = false;
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.updateComponentData();
            }
        });
    }
    updateComponentData() {
        if (+this.jobId > 0 && this.selectedApplication) {
            this.showMap = true;
            this.selectedApplicationStatus = this.selectedApplication.isAdvetisingPermanentOrTemporary;
            // const advertisementControl = this.getAdvertisements();
            // let point: IAPoint;
            // let polygon: IAPolygon;
            // const isAdvertisingPermanentOrTemporaryValue = this.selectedApplication.isAdvetisingPermanentOrTemporary;
            // this.advertisementsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).setValue(isAdvertisingPermanentOrTemporaryValue)
            //
            // if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === "permanent") {
            //     point = this.selectedApplication.point;
            // }
            //
            // if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === "temporary") {
            //     polygon = this.selectedApplication.polygon;
            // }
            //
            // const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(isAdvertisingPermanentOrTemporaryValue.toLowerCase() === "temporary" ? polygon.shape : point.shape, 102100)
            // const geom = JsonUtils.fromJSON(geometryArc);
            // const updatedAdvertisementFormGroup = this.getUpdatedAdvertisementFormGroup(this.selectedApplication, geom);
            // this.advertisementsForm.markAllAsTouched();
            // this.applicationCreateService.getPropertyCentroidObservable(geom).subscribe({
            //     next: (trueCentroidResponse) => {
            //         CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, updatedAdvertisementFormGroup);
            //         advertisementControl.push(updatedAdvertisementFormGroup);
            //         this.activeTabIndex = advertisementControl.length - 1;
            //         this.syncMapGeometries();
            //         if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === "permanent") {
            //             this.showPermanentApplicationsFields = true;
            //             this.showTemporaryApplicationsFields = false;
            //         }
            //
            //         if (isAdvertisingPermanentOrTemporaryValue?.toLowerCase() === "temporary") {
            //             this.showTemporaryApplicationsFields = true;
            //             this.showPermanentApplicationsFields = false;
            //         }
            //         this.changeDetectorRefs.detectChanges();
            //     }, error: (error) => {
            //         this.appControllerService.handleServerErrorMessage(CreateApplicationLocationAConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            //     }
            // })
            //
            // if (this.isMapLoaded) {
            //     this.syncMapGeometries();
            // }
            this.changeDetectorRefs.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: MapTools },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: NgbModal },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esriMap", { static: false },] }]
    };
};
CreateApplicationLocationAComponent = __decorate([
    Component({
        selector: "app-create-application-location-a",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationAComponent);
